import { combine, withCallbacks, withContext } from 'react-hooks-combine'
import { withRouter } from 'react-router'
import { admin } from 'routes/route.map'
import { ServicesContext } from 'services/context'
import { withTableController } from 'shared/hooks'
import { StoreContext } from 'store/context'

import InvoiceButtonComponent from './component'

export const Invoice = combine({
  hocs: [withRouter],
  hooks: [
    withTableController({ id: 'athletes-table' }),
    withContext('appStore', StoreContext),
    withContext(
      'adminMemberService',
      ServicesContext,
      ({ adminMemberService }) => adminMemberService
    ),
    withCallbacks(
      {
        onRouteToInvoiceOverview:
          ({ adminMemberService }, { value, history }) =>
          async () => {
            const memberInfo = await adminMemberService.getMemberByEmail(
              value.email
            )
            history.push(admin.sponsors.invoices.view(memberInfo.id))
          },
      },
      ['value']
    ),
  ],
})(InvoiceButtonComponent)
